// extracted by mini-css-extract-plugin
export default {"container":"PediYa_container__+yTE1","pediya":"PediYa_pediya__cEMUV","montototal":"PediYa_montototal__Lb-iZ","linea":"PediYa_linea__SMD16"};